import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIndustrialTruck = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 120,
	height: 20,
	viewBox: "0 0 120.0 20.0",
	...props,
	children: [
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 25,
			cy: 10,
			rx: 10,
			ry: 10,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 95,
			cy: 10,
			rx: 10,
			ry: 10,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 0.0 0.0 L 120.0 0.0",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		})
	]
});
export default SvgIndustrialTruck;
